import { render, staticRenderFns } from "./banner-add.vue?vue&type=template&id=1238db52&scoped=true"
import script from "./banner-add.vue?vue&type=script&lang=ts"
export * from "./banner-add.vue?vue&type=script&lang=ts"
import style0 from "./banner-add.vue?vue&type=style&index=0&id=1238db52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238db52",
  null
  
)

export default component.exports